import React, { useState, useEffect, useMemo } from 'react';
import sensorsApi from '../api/sensorsApi';
import { STATIC_ICONS } from '../Constants';
import './ImageButton.css';

const ImageButton = ({ title, transparentBackground, value, images, alignment, draggable, pin, did, tid }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [cursorState, setCursorState] = useState('idle');

  useEffect(() => {
    const current = images?.find(img => parseFloat(img.value) === parseFloat(value));
    setSelectedImage(current);
  }, [value, images]);

  const handleToggle = () => {
    const newImage = images?.find(img => parseFloat(img.value) !== parseFloat(selectedImage?.value));

    if (did && newImage) {
      const body = JSON.stringify({
        device: did,
        template: tid,
        data: { [pin]: Number(newImage.value).toString() }
      });

      sensorsApi.control(body)
        .then(res => {
          console.log(res.data);
          setSelectedImage(newImage);
        })
        .catch(err => console.log(err));
    }
  };

  const getImageSrc = useMemo(() => (image) => {
    if (image?.file instanceof File || image?.file instanceof Blob) {
      return URL.createObjectURL(image.file);
    }

    if (typeof image?.imageUrl === 'string' && image.imageUrl.trim() !== '') {
      const url = image.imageUrl.trim();

      if (url.startsWith('icons/')) {
        return STATIC_ICONS + url.replace(/^icons\//, '');
      }

      return STATIC_ICONS + url;
    }

    return '';
  }, []);

  const cursorClass = draggable
    ? (cursorState === 'grabbing' ? 'image-button--grabbing' : 'image-button--grab')
    : 'image-button--auto';

  return (
    <div
      className={[
        "widget-container",
        "image-button",
        cursorClass,
        transparentBackground ? "image-button--transparent" : "",
      ].filter(Boolean).join(" ")}
      onMouseDown={() => draggable && setCursorState('grabbing')}
      onMouseUp={() => draggable && setCursorState('grab')}
      onMouseLeave={() => draggable && setCursorState('grab')}
      draggable={draggable}
      onDragStart={(e) => {
        const id = e.target.closest('.widget')?.id;
        if (!id) return;
        const rect = e.target.getBoundingClientRect();
        const offsetX = e.clientX - rect.x;
        const offsetY = e.clientY - rect.y;
        let dragData = `image-button;${id};${offsetX};${offsetY};${id.startsWith('base') ? 'add' : 'move'}`;
        e.dataTransfer.setData('text/plain', dragData);
      }}
    >
      <h3 className="image-button__title">{title ? `${title}${pin ? ` [${pin}]` : ''}` : ''}</h3>

      <div className="background-image-container">
        {selectedImage ? (
          <img
            className="background-image-preview"
            src={getImageSrc(selectedImage)}
            alt="Toggle"
            onClick={handleToggle}
          />
        ) : (
          <div className="background-image-container image-button__missing" onClick={handleToggle}>
            Value doesn't exist
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageButton;
